import igcmImg from "../../assets/images/igcm_img.jpeg";
import kdsImg from "../../assets/images/kds_img.jpeg";
import dmbImg from "../../assets/images/dmb_img.jpeg";
 export async function SearchTenants(name = '', getAll = false) {
    let tenants = [];
    try {
        const response = await fetch('/TenantSearch', { 
            body: JSON.stringify({
                "name": name,               
                "getAll": getAll
            }),
            method: "POST",
        });
        if (response && response.status === 200) {
            const json = await response.json()
            if (json)
                tenants = json.map(x => ({ label: x.Name, value: x.Id }));
        }
    } catch (err) {
        console.error(err);
    }

    return tenants;
}
export async function FetchTenantEnvironment(tenantId, app) {
   let redirectapp = null;
   try { 
        const response = await fetch('/Lookup', { 
            body: JSON.stringify({ "TenantId": tenantId }),
            method: "POST" 
        });
        if (response && response.status === 200) {
            const env = await response.json()
            if (env) {
                let details = JSON.parse(env.Details);
                redirectapp = details.apps[app]?.url;
            }
        }
    } 
    catch (err) {
      console.error(err);
    }
   return redirectapp;
}

export async function clearCookies(appName) {
    try {
        await fetch('/ClearCookies', { 
            body: JSON.stringify({ "AppName": appName }),
            method: "POST"
        });
    }
    catch(err) {
        console.error(err);
    }
}

export async function FetchAccessDetails() {
    let access = false; 
    try { 
         const response = await fetch('/GetAccessDetails'); 
         if (response && response.status === 200) {
             const accessDetails = await response.json();
             if (accessDetails && accessDetails.userName) {
                access = true;
             }
         }
     } 
     catch (err) {
       console.error(err);
     }
    return access;
}

export async function GetAllApps() {

    return Promise.resolve([{ label: 'IG Configuration Manager', name: 'igcm', redirectapp: '/igcm', url: '/udweb', img: igcmImg }
        , { label: 'IG Digital Menu Board', name: 'dmb', redirectapp: '/board', url: '/board', img: dmbImg }
        , { label: 'IG KDS', name: 'kds', redirectapp: '/kds/', url: '/kds/', img: kdsImg }
        , { label: 'IG Check Zoom', name: 'checkzoom', redirectapp: '/checkzoom', url: '/checkzoom', img: igcmImg }
        ,{ label: 'IG Health Monitor', name: 'healthmonitor', redirectapp: '/healthmonitor', url: '/ighealthmonitor', img: igcmImg }])
}